export default __webpack_public_path__ + "static/background-69aa81f8f957d48403977fa6a3f67090.svg";